import React, { memo, useCallback, useEffect, useState } from 'react';
import { Slider } from '@components/Slider';
// import '@style/modules/insights/maturityAssessment.scss';
import '../../../styles/modules/insights/maturityAssessment.scss';
import Dropdown, {
  MATURITY_ASSESSMENT,
} from '@modules/insights/insightsDropdown';
import SectionComment from 'src/ddvComment/SectionComment';
import CommentAnchor from 'src/ddvComment/directUser/CommentAnchor';
import { connect, useSelector, useDispatch } from 'react-redux';
import './maturityAssessment.scss';

import * as maturityAssessmentTemplateData from './data.json';
import { API } from '@service';
import actions from '@flux/action';
import LeadingPractice from '@modules/insights/maturityAssessment/leadingPractice/leadingPractice';
import { projectRole } from '@model';

function MaturityAssessment({ currentSubmoduleName }) {
  const staticData = maturityAssessmentTemplateData.default;
  const [data, setData] = useState(null);
  // const [isRangeShow, setIsRangeShow] = useState(true);
  const [expand, setExpand] = useState(true);
  const projectId = useSelector((state) => state.common.currentId);
  const { companyInstance, currentUserPermission } = useSelector(
    (state) => state.common.projectCompanyInfo,
  );
  const dispatch = useDispatch();
  const isClient = JSON.parse(window.localStorage.userInfo || '{}')?.isClient;
  const isReadonly = currentUserPermission === projectRole['View-Only'];

  const changeLoading = useCallback((isLoading) => {
    dispatch(actions.changeLoading(isLoading));
  }, []);
  useEffect(() => {
    if (!projectId) {
      return;
    }
    changeLoading(true);
    API.getMaturityAssessmentData(projectId)
      .then((result) => {
        setData(result);
      })
      .finally(() => {
        changeLoading(false);
      });
  }, [projectId]);

  const onSliderChange = useCallback(
    (value, key) => {
      if (!(value && key && projectId)) {
        return console.warn('missing argument');
      }
      changeLoading(true);
      API.saveMaturityAssessmentData(projectId, {
        maturityAssessmentInfo: {
          [key]: value,
        },
      })
        .then((result) => {
          // setData(result);
        })
        .finally(() => {
          changeLoading(false);
        });
    },
    [projectId],
  );

  return (
    <div className={`maturityAssessment ${expand ? 'expand-right' : ''}`}>
      {companyInstance ? <Dropdown section={MATURITY_ASSESSMENT} /> : null}
      <SectionComment module={currentSubmoduleName} placement="bottomRight" />
      <div className="MaturityAssessmentContainer">
        <div className="Header-left">Competencies</div>
        <div className="Header-right">
          Organizational Maturity
          {/*<div>*/}
          {/*  Healthy Range*/}
          {/*  <Switch*/}
          {/*    // type="left is true"*/}
          {/*    textLeft="Off"*/}
          {/*    textRight="On"*/}
          {/*    onChange={setIsRangeShow}*/}
          {/*    checked={isRangeShow}*/}
          {/*    size="small"*/}
          {/*  />*/}
          {/*</div>*/}
        </div>
        <div className="Sections">
          {data
            ? staticData.map((areas) => {
                const { name: area, competencies } = areas;
                return (
                  <div className="Section" key={area}>
                    <span className="Title">{area}</span>
                    <div className="Legend">
                      <span>Lagging</span>
                      <span>Basic</span>
                      <span>Leading</span>
                    </div>
                    <div className="Content">
                      {competencies.map((competency) => {
                        const { name, tooltip, score, range, key } = competency;
                        return (
                          <div className="Row" key={key}>
                            <div className="Name">{name}</div>
                            <Slider
                              id={key}
                              min={1}
                              max={5}
                              defaultValue={data[key] || score}
                              healthyRange={range}
                              showHealthyRange={false}
                              onChange={onSliderChange}
                              disabled={isClient || isReadonly}
                              tooltipTitle={name}
                              tooltipData={tooltip}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </div>
      <LeadingPractice expand={expand} onExpandChange={setExpand} />
    </div>
  );
}

export default CommentAnchor(connect(() => {})(memo(MaturityAssessment)), {
  shouldScrollInToView: (anchorRecord, anchorId) =>
    anchorRecord?.moduleName === anchorId,
  getAnchorIdFromProp(props) {
    return props.currentSubmoduleName;
  },
});
